import { useContext } from "react";

import { ApiContext } from "./context/ApiContextProvider";

export const useApiClient = () => {
  const apiContext = useContext(ApiContext);

  if (!apiContext) {
    throw new Error("useApiClient must be used within an ApiContextProvider");
  }

  return apiContext.apiClient;
};
